import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, MainHeading, SpanStyled } from '../../../../ui/Elements'
import { ServicesList6 } from '../../../projectData/Data';
import { ArrowBtnBrown } from '../../../../ui/AllImages';
import { ServicesColContainer } from './Styled';



const ServicesListing6 = () => {
    const { t, i18n } = useTranslation();

    return (
        <ServicesColContainer>
            {ServicesList6.map((item, index) => (
                <Box className='servicesColInner' key={index}>
                    <Box className='servicesBox'>
                        {item.img}
                    </Box>
                    <Box className='servicesColInnerContent'>
                        <Box className='itemTitle'>
                            <MainHeading className='main-heading mb-3' size="24px" color="var(--themeColor)" family="var(--hBold)">
                                {t(item.title)}
                            </MainHeading>
                        </Box>
                        <Box className='itemTxt'>
                            <SpanStyled className='d-flex mb-4 transformTxt' color='var(--secondaryColor)'>
                                {t(item.txt)}
                            </SpanStyled>
                        </Box>
                        <Box className="ctPointsList">
                            <ul>
                                {item.listing.map((item, itemIndex) => (
                                    <li key={itemIndex}>
                                        <Box className='checkList'>
                                            <ArrowBtnBrown />
                                        </Box>
                                        <Box className='listContent'>
                                            <SpanStyled lh="1.5">
                                                {t(item.listTxt)}
                                            </SpanStyled>
                                        </Box>
                                    </li>
                                ))}
                            </ul>
                        </Box>
                    </Box>
                    
                </Box>
            ))}
        </ServicesColContainer>
    )
}

export default ServicesListing6